import { ReactSVG } from "react-svg";

export const ExpandButton = ({
  expanded,
  setExpanded,
  buttonType,
  darkMode,
}) => {
  return (
    <button
      className="flex text-stone-300 text-xxs"
      onClick={() =>
        expanded !== buttonType ? setExpanded(buttonType) : setExpanded(null)
      }
    >
      <ReactSVG
      
        src={expanded !== buttonType ? "expand.svg" : "zoomout.svg"}
        className={`${
          expanded !== buttonType
            ? "md:w-3 md:h-3 w-2 h-2"
            : "md:w-5 md:h-5 w-4 h-4"
        }`}
        beforeInjection={(svg) => {
          svg.setAttribute("style", `stroke: ${darkMode ? "white" : "black"}`);
        }}
      />

      {/* <img
          src={expanded !== buttonType ? "expand.svg" : "zoomout.svg"}
          alt="expand"
          className={`${
            expanded !== buttonType
              ? "md:w-3 md:h-3 w-2 h-2"
              : "md:w-5 md:h-5 w-4 h-4"
          }`}
        /> */}
    </button>
  );
};
